module.exports = __webpack_public_path__ + "img/рз_29.a3972807.png";